import { Link } from 'react-router-dom';
import { useAuth } from 'auth/AuthProvider';
import { useI18n } from 'core/i18n/I18nProvider';
import { firstAccessiblePath, paths } from 'core/routing/paths';

export function NotFoundPage() {
  const { t } = useI18n();
  const { isAuthenticated, admin, permissions } = useAuth();
  const home = isAuthenticated ? firstAccessiblePath(admin || permissions) : paths.login;
  const destination = home === paths.forbidden ? paths.login : home;

  return (
    <main className="forbidden-page">
      <p className="brand-mark">{t('appName')}</p>
      <p className="code-403">404</p>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link className="btn btn-primary" to={destination}>{t('notFound.home')}</Link>
    </main>
  );
}
